import { TSalesManager } from '@internal/services/TSalesManager';
import { localeNamespace } from '@internal/utils/machine/i18n/Locale';
import { TLocale } from '@internal/utils/machine/i18n/TLocale';
import { Typography } from '@renderer-ui-library/mui';
import { lightPetrol } from '@renderer-ui-library/mui/base/colors.module.scss';
import { translations } from 'i18n/translations';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { ProfilePicture } from '../Media/ProfilePicture';
import { MachineDetailsContactButtons } from './MachineDetailsContactButtons';
import styles from './machineDetailsContact.module.scss';

interface Props {
    salesManagers: TSalesManager[];
    machineGroupId: string;
    locale: TLocale;
}

export const MachineDetailsContactInfo: React.FC<Props> = React.memo(
    ({ salesManagers, machineGroupId, locale }) => {
        const { t } = useTranslation(localeNamespace.common);

        return (
            <div className={styles.contactWrapper}>
                <div className={styles.headlineWrapper}>
                    <Typography
                        variant="h6"
                        className={styles.contactHeadline}
                        sx={{ textTransform: 'uppercase' }}
                    >
                        {salesManagers.length > 1
                            ? t(translations.yourContacts)
                            : t(translations.yourContact)}
                    </Typography>
                </div>

                <div className={styles.contactInfoContainerDesktop}>
                    {salesManagers.map(contact => (
                        <div className={styles.contactInfo} key={contact.id}>
                            <div className={styles.imageWrapper}>
                                <ProfilePicture
                                    salesManager={contact}
                                    variant="avatar"
                                    size={64}
                                />
                            </div>
                            <div>
                                <Typography
                                    variant="h6"
                                    color="primary"
                                    textTransform="uppercase"
                                    className={styles.contactPersonName}
                                >
                                    {`${contact.firstName} ${contact.lastName}`}
                                </Typography>
                                <Typography
                                    variant="subtitle2"
                                    color={lightPetrol}
                                >
                                    {contact.jobTitle}
                                </Typography>
                            </div>
                        </div>
                    ))}

                    {salesManagers.length > 0 && (
                        <MachineDetailsContactButtons
                            isMobile={false}
                            contact={salesManagers[0]}
                            machineGroupId={machineGroupId}
                            locale={locale}
                        />
                    )}
                </div>
            </div>
        );
    },
);

MachineDetailsContactInfo.displayName = 'MachineDetailsContactInfo';
